import React from 'react';
import Providers from 'components/templates/Providers/Providers';
import ViewsWrapper from 'components/views/ViewsWrapper/ViewsWrapper';

const Root = () => {
  return (
    <Providers>
      <ViewsWrapper />
    </Providers>
  );
};

export default Root;
